import type { AdminOrderDetail, OrderStatus, PaymentStatus } from '../../domain/entities/AdminOrder';

type AdminOrderItemApi = {
  id: string;
  product_name: string;
  product_entity_type: string;
  product_entity_id: string;
  unit_price: number | string;
  quantity: number;
  subtotal: number | string;
  metadata?: Record<string, unknown> | null;
};

type AdminOrderPaymentApi = {
  id: string;
  amount: number | string;
  status: string;
  method: string;
  gateway_reference: string | null;
  created_at: string;
};

export type AdminOrderApi = {
  id: string;
  order_number: string;
  user: { id: string; name: string; email: string };
  status: OrderStatus;
  payment_status: PaymentStatus;
  payment_method: string | null;
  payment_reference: string | null;
  subtotal: number | string;
  tax: number | string;
  total: number | string;
  currency: string;
  billing_info: Record<string, unknown> | null;
  notes: string | null;
  items?: AdminOrderItemApi[];
  payments?: AdminOrderPaymentApi[];
  paid_at: string | null;
  completed_at: string | null;
  created_at: string;
  updated_at: string;
};

export class AdminOrderMapper {
  static toDomain(dto: AdminOrderApi): AdminOrderDetail {
    return {
      id: dto.id,
      orderNumber: dto.order_number,
      user: {
        id: dto.user.id,
        name: dto.user.name,
        email: dto.user.email,
      },
      status: dto.status,
      paymentStatus: dto.payment_status,
      paymentMethod: dto.payment_method,
      paymentReference: dto.payment_reference,
      subtotal: Number(dto.subtotal),
      tax: Number(dto.tax),
      total: Number(dto.total),
      currency: dto.currency,
      billingInfo: dto.billing_info,
      notes: dto.notes,
      items: (dto.items || []).map((item) => ({
        id: item.id,
        productName: item.product_name,
        productEntityType: item.product_entity_type,
        productEntityId: item.product_entity_id,
        unitPrice: Number(item.unit_price),
        quantity: item.quantity,
        subtotal: Number(item.subtotal),
        metadata: item.metadata ?? null,
      })),
      payments: (dto.payments || []).map((payment) => ({
        id: payment.id,
        amount: Number(payment.amount),
        status: payment.status,
        method: payment.method,
        gatewayReference: payment.gateway_reference,
        createdAt: payment.created_at,
      })),
      paidAt: dto.paid_at,
      completedAt: dto.completed_at,
      createdAt: dto.created_at,
      updatedAt: dto.updated_at,
    };
  }
}
